import { render, staticRenderFns } from "./allGoods.vue?vue&type=template&id=52b984e4&scoped=true&"
import script from "./allGoods.vue?vue&type=script&lang=js&"
export * from "./allGoods.vue?vue&type=script&lang=js&"
import style0 from "./allGoods.vue?vue&type=style&index=0&id=52b984e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b984e4",
  null
  
)

export default component.exports